import styled from 'styled-components'

import { ConnectorNodeDefs } from '../../model/nodes'

import type { StyleProps } from '@root/shared/react'

type ConnectorNodeProps = {
  ref?: React.Ref<HTMLDivElement | null>
} & StyleProps

export const ConnectorNode: React.FC<ConnectorNodeProps> = ({ style, ref }) => {
  return <Root style={style} ref={ref}></Root>
}

const Root = styled.div`
  width: ${ConnectorNodeDefs.width}px;
  height: ${ConnectorNodeDefs.height}px;
  background: var(--background-5);
  border-radius: 50%;
`
